import {useState} from "react";
import Modal from "./Modal";
import ModalCard from "./ModalCard";
import ModalActions from "./ModalActions";
import Checkbox from "../form/Checkbox";
import DatePickerInput from "../form/DatePickerInput";
import FormField from "../form/FormField";
import {exportReservations} from "../../shared/queries";
import {ExportColumn} from "../../types";
import HotelSelector from "../navigation/HotelSelector";
import dayjs from "dayjs";
import toast from "react-hot-toast";
import {useTranslation} from "react-i18next";
import DateRangePicker from "../form/DateRangePicker";
import SelectInput from "../form/SelectInput";
import AccountingReport from "../business/invoices/AccountingReport";
import Button from "../form/Button";
import {fetchReport, setAccommodation} from "../../store/slices/accountingReportSlice";
import {useSelector} from "react-redux";
import {useAppDispatch, useAppSelector} from "../../hooks/redux";

export default function ExportModal ({
  currentHotel,
  columns = [],
  visible = false,
  onClose
} : {
  currentHotel: string | number,
  columns: ExportColumn[],
  visible: boolean,
  onClose: () => void
}) {

  const { t } = useTranslation()

  const dispatch = useAppDispatch()

  const currentHotelObject = useSelector<any>(state => state.hotels.currentHotelObject) as any
  const { dataUrl, loading } = useAppSelector(state => state.reportSlice)

  async function handleExport () {
    try {
      if (!currentHotelObject) {
        alert('Devi selezionare un hotel')
        return
      }
      await dispatch(setAccommodation(currentHotelObject))
      await dispatch(fetchReport())
      const a = document.createElement('a')

      if (dataUrl) {
        a.href = dataUrl;
        a.download = "besaferate_reservation_export.xlsx"
        document.body.appendChild(a)
        a.click()
        a.remove()
        toast.success('Export completato, trovi il file nei download')
      } else {
        toast.error('Error generating accounting report')
      }
    } catch (e) {
      console.log(e)
    }
  }

  return (
    <Modal
      visible={visible}>
      <ModalCard
        className={'w-full max-w-lg'}
        title={t('accountReport.title')}
        onSave={() => handleExport()}
        onClose={onClose}
        actionsLoading={loading.report}>
        <div className="pb-4">
          <AccountingReport />
        </div>
      </ModalCard>
    </Modal>
  )

}
